export default __webpack_public_path__ + "static/media/cs-a009-5.84738dbc.svg";